export const en = {
    'phrases-caption': 'Keywords: {count}',
    'phrases-placeholder': 'Enter keywords, one per line.'
};
